import React, { CSSProperties, FC } from 'react';
import { Icon, Label }              from 'semantic-ui-react';
import { useFormikContext }         from 'formik';
import { Cell, Grid }               from 'styled-css-grid';
import _                            from 'underscore';

interface Props {
	name: string,
	error: null | string,
	style?: CSSProperties,
}

const defaultProps: Props = {
	name:  null,
	error: null,
	style: {},
}

const FormPointerErrorMessage: FC<Props> = ( props ) => {
	
	let formik = useFormikContext();
	
	return <Label basic pointing
	              color={ 'red' }
	              className={ 'fade-in text-left' }
	              style={ {
		              position: 'absolute',
		              top:      '100%',
		              left:     0,
		              zIndex:   2,
		              ...props.style
	              } }>
		
		<span className={ 'display--inline-block' }>
			<Grid columns={ `auto 14px` } rows={ 1 } columnGap={ '5px' }>
				<Cell middle>{ props.error }</Cell>
				<Cell middle>
					<Icon fitted name={ 'close' }
					      onClick={ ( formik && props.name ) ? () => { formik.setFieldError( props.name, null ) } : null }/>
				</Cell>
			</Grid>
		</span>
	
	</Label>
};

FormPointerErrorMessage.defaultProps = defaultProps;

export { FormPointerErrorMessage };
